import { useState, useEffect } from "react";
import "./index.scss";

import Cash from "../../../Shared/ObonLandingPage/Cash/index.jsx";
import Mission from "../../../Shared/ObonLandingPage/Mission/index.jsx";
import Partner from "../../../Shared/ObonLandingPage/Partners/index.jsx";
import Contact from "../../../Shared/ObonLandingPage/Contact/index.jsx";
import Features from "../../../Shared/ObonLandingPage/Features/index.jsx";
import ObonAbout from "../../../Shared/ObonLandingPage/ObonAbout/index.jsx";
import Embarassed from "../../../Shared/ObonLandingPage/Embarrased/index.jsx";
import CanvaBanner from "../../../Shared/CanvaLandingPage/Banner/HomeBanner.jsx";
import CanvaContact from "../../../Shared/ObonLandingPage/CanvaContact/index.jsx";
import PartnerWithUs from "../../../Shared/ObonLandingPage/PartnerWithUs/index.jsx";
import International from "../../../Shared/ObonLandingPage/InternationHassle/index.jsx";

import {
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Collapse,
  NavbarToggler,
} from "reactstrap";

const LandingPage = (args) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const navData = [
    { id: "#canvabanner", label: "Home" },
    { id: "#canvaAbout", label: "About Us" },
    { id: "#canvaBusiness", label: "Business Advantages" },
    { id: "#canvaFeatures", label: "Features" },
    { id: "#canvaCash", label: "No Cash, No Problem" },
    { id: "#canvaTip", label: "Tip&Go" },
    { id: "#canvaInternational", label: "International Tipping" },
    { id: "#canvaTestimonials", label: "Testimonials" },
    { id: "#canvaSalesTeam", label: "Sales Team" },
    { id: "#canvaContact", label: "Contact Us" },
  ];

  const scrollToSection = (sectionId) => {
    const targetElement = document.querySelector(sectionId);

    if (targetElement) {
      const offset = sectionId === "#canvabanner" ? 100 : 0;

      window.scroll({
        top: targetElement.offsetTop - offset,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Navbar className="bg-light" expand={"md"} fixed="top">
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="me-auto flex-column flex-md-row">
            {navData?.map(({ id, label }) => (
              <NavItem key={id}>
                <NavLink
                  className="text-dark canvaCursorPointer"
                  onClick={() => scrollToSection(id)}
                  style={{ width: "100%"  }}
                >
                  {label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Collapse>
      </Navbar>

      <CanvaBanner />
      <ObonAbout />
      <Mission />
      <Features />
      <Cash />
      <Embarassed />
      <International />

      <Partner />
      <PartnerWithUs />

      <CanvaContact />

      {/* <Contact /> */}
    </>
  );
};

export default LandingPage;
